import { render, staticRenderFns } from "./AccountPaymentPlan.vue?vue&type=template&id=4b2332c4&scoped=true&"
import script from "./AccountPaymentPlan.vue?vue&type=script&lang=js&"
export * from "./AccountPaymentPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2332c4",
  null
  
)

export default component.exports